var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuspended(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "62px",
    height: "62px",
    viewBox: "0 0 62 62",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Add") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "start",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "portal---suspended",
    transform: "translate(-585.000000, -247.000000)",
    stroke: "#043F93",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Add",
    transform: "translate(586.000000, 248.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-1788",
    cx: 30,
    cy: 30,
    r: 30
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3933983,19.3933983 L40.6066017,40.6066017",
    id: "Line"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9854521,40.7755786 L40.1986555,19.5623751",
    id: "Line-401"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuspended);
export default __webpack_public_path__ + "static/media/Suspended.54637639751c5fd6fc1260f97e5427b9.svg";
export { ForwardRef as ReactComponent };